const TELEMETRY_BODY_LIMIT = 5000;

export const truncateForTelemetry = (value: unknown): string => {
  if (typeof value === 'string') return value.slice(0, TELEMETRY_BODY_LIMIT);
  if (value === undefined || value === null) return '';

  try {
    return JSON.stringify(value).slice(0, TELEMETRY_BODY_LIMIT);
  } catch {
    return String(value).slice(0, TELEMETRY_BODY_LIMIT);
  }
};
